import { useState, type ReactNode } from "react";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";

/** Shared collapsible card scaffold for history/comparison rows: a left-border
 * accent header line that expands into a detail panel. */
export function CollapsibleRow({
  border,
  defaultExpanded = false,
  left,
  right,
  children,
}: {
  border: string;
  defaultExpanded?: boolean;
  left: ReactNode;
  right?: ReactNode;
  children: ReactNode;
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  return (
    <div>
      <button
        onClick={() => setExpanded(!expanded)}
        className={`
          flex items-center w-full bg-card border-l-3 ${border}
          pl-4 pr-5 h-11 transition-shadow hover:shadow-[0_1px_4px_rgba(0,0,0,0.04)]
          ${expanded ? "" : "rounded-r-lg"}
        `}
      >
        <div className="flex items-center flex-1 min-w-0 gap-3">{left}</div>
        <div className="flex items-center gap-2 shrink-0">
          {right}
          {expanded ? (
            <IconChevronUp className="h-3.5 w-3.5 text-muted-foreground" />
          ) : (
            <IconChevronDown className="h-3.5 w-3.5 text-muted-foreground" />
          )}
        </div>
      </button>
      {expanded && (
        <div className={`bg-card border-l-3 ${border} rounded-br-lg pl-4 pr-5 py-3 overflow-x-auto`}>
          {children}
        </div>
      )}
    </div>
  );
}
